module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "room-detail"
  }, [(!_vm.$media.isMobile) ? [_c('h2', [_vm._v("操作")]), (_vm.$permission.has("basic.create.contracts")) ? _c('div', {
    staticClass: "ui button themed labeled icon",
    class: {
      disabled: !_vm.can_sign
    },
    on: {
      "click": _vm.goto_sign
    }
  }, [_c('i', {
    staticClass: "icon file text"
  }), _vm._v("新签合同")]) : _vm._e(), (_vm.$permission.has("basic.create.preorders")) ? _c('div', {
    staticClass: "ui button themed labeled icon",
    class: {
      disabled: !_vm.can_preorder
    },
    on: {
      "click": _vm.goto_sign_preorder
    }
  }, [_c('i', {
    staticClass: "icon pin"
  }), _vm._v("房屋预约")]) : _vm._e()] : _vm._e(), _c('h2', [_vm._v("预定单 (" + _vm._s(_vm.preorders.length) + ")")]), _c('auto-table', {
    attrs: {
      "unstackable": "unstackable",
      "defines": _vm.$defines.preorder,
      "data": _vm.sorted_preorders,
      "detail-view": true,
      "actions": _vm.get_preorder_actions,
      "layout": "detailed_table"
    },
    on: {
      "action:order": _vm.goto_preorder,
      "action:cancel": _vm.open_cancel_preorder_dialog
    }
  }), _c('h2', [_vm._v("全部合同")]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.contract,
      "unstackable": "unstackable",
      "data": _vm.contracts,
      "detail-view": true,
      "actions": "goto"
    },
    on: {
      "action:goto": _vm.goto_contract
    }
  }), _c('h2', [_vm._v("房间水电记录")]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.charge,
      "unstackable": "unstackable",
      "data": _vm.charges,
      "detail-view": true
    }
  }), _c('dialog-cancel-preorder', {
    attrs: {
      "preorder": _vm.preorder_canceling,
      "room": _vm.room,
      "visible": _vm.dialog_preorder_cancel
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_preorder_cancel = $event
      },
      "exit": function($event) {
        _vm.fetch_preorders()
      }
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4d62576","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/mixed/RoomDetail.vue
// module id = 447
// module chunks = 0